/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/alerttype";
const alerttypeService = {
    getalerttypes: async (partnerOrgId) => {
        const response = await http.get(`${controller}/alerts?partnerId=${partnerOrgId}`);
        return response.data;
    },
    
    getanalyticalerttypes: async () => {
        const response = await http.get(`${controller}/getanalyticalerttypes`);
        return response.data;
    }
};
export default alerttypeService;